import { render, staticRenderFns } from "./PengurusPusatAdd.vue?vue&type=template&id=a638019e&scoped=true"
import script from "./PengurusPusatAdd.vue?vue&type=script&lang=js"
export * from "./PengurusPusatAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a638019e",
  null
  
)

export default component.exports